import { Document } from "../../api";
import { IdentifiedSubscription } from "../models/subscriptions.interface";

export const FETCH_SUBSCRIPTIONS = "FETCH_SUBSCRIPTIONS";
export const FETCH_DOCUMENTS = "FETCH_DOCUMENTS";

export interface FetchSubscriptionsAction {
  type: typeof FETCH_SUBSCRIPTIONS;
}
interface RequestSubscriptionsAction {
  type: "REQUEST_SUBSCRIPTIONS";
}
interface SetSubscriptionsAction {
  type: "SET_SUBSCRIPTIONS";
  data: IdentifiedSubscription[];
}
interface SetSubscriptionsErrorAction {
  type: "SET_SUBSCRIPTIONS_ERROR";
}

export interface FetchDocumentsAction {
  type: typeof FETCH_DOCUMENTS;
  subscription: string;
}
interface RequestDocumentsAction {
  type: "REQUEST_DOCUMENTS";
  subscription: string;
}
interface SetDocumentsAction {
  type: "SET_DOCUMENTS";
  subscription: string;
  items: Document[];
  expires: number;
}
interface SetDocumentsErrorAction {
  type: "SET_DOCUMENTS_ERROR";
  subscription: string;
}

export type KnownAction =
  | FetchSubscriptionsAction
  | RequestSubscriptionsAction
  | SetSubscriptionsAction
  | SetSubscriptionsErrorAction
  | FetchDocumentsAction
  | RequestDocumentsAction
  | SetDocumentsAction
  | SetDocumentsErrorAction;

export const fetchSubscriptions = (): FetchSubscriptionsAction =>
  ({ type: FETCH_SUBSCRIPTIONS });

export const setSubscriptions = (data: IdentifiedSubscription[]): SetSubscriptionsAction =>
  ({ type: "SET_SUBSCRIPTIONS", data });

export const setSubscriptionsLoading = (): RequestSubscriptionsAction =>
  ({ type: "REQUEST_SUBSCRIPTIONS" });

export const setSubscriptionsError = (): SetSubscriptionsErrorAction =>
  ({ type: "SET_SUBSCRIPTIONS_ERROR" });

export const fetchDocuments = (
  subscription: string): FetchDocumentsAction =>
  ({ type: FETCH_DOCUMENTS, subscription });

export const setDocuments = (
  subscription: string,
  items: Document[],
  expires: number): SetDocumentsAction =>
  ({ type: "SET_DOCUMENTS", subscription, items, expires });

export const setDocumentsLoading = (
  subscription: string): RequestDocumentsAction =>
  ({ type: "REQUEST_DOCUMENTS", subscription });

export const setDocumentsError = (
  subscription: string): SetDocumentsErrorAction =>
  ({ type: "SET_DOCUMENTS_ERROR", subscription });
